import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

/**
 * Thumbtack icon — used as the "pin as default" indicator on saved filters.
 */
export const Thumbtack = (props: CustomFontAwesomeIconProps) => {
  return (
    <FontAwesomeIcon
      icon={['fass', 'thumbtack']}
      {...props}
    />
  );
};
